import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '@/App.vue'
import router from '@/router'
import 'primeicons/primeicons.css'
import './style.css'
import { useUserStore } from '@/stores/userStore'

import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'
import Aura from '@primeuix/themes/aura'
import ToastService from 'primevue/toastservice'
import { createI18n } from 'vue-i18n'
import ruLocale from './locale/ru.json'
import { definePreset } from '@primeuix/themes'

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      500: 'rgb(20, 142, 40)',
    },
    success: {
      500: 'rgb(20, 142, 40)',
    },
  },
  components: {
    selectbutton: {
      root: {
        borderRadius: '1rem !important',
      },
    },
    button: {
      colorScheme: {
        light: {
          root: {
            success: {
              background: 'rgb(20, 142, 40)',
              hoverBackground: 'rgb(17, 124, 35)',
              activeBackground: 'rgb(14, 104, 30)',
              borderColor: 'rgb(20, 142, 40)',
              hoverBorderColor: 'rgb(17, 124, 35)',
              activeBorderColor: 'rgb(14, 104, 30)',
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
              focusRing: {
                color: 'rgb(20, 142, 40)',
                shadow: 'none',
              },
            },
          },
          outlined: {
            success: {
              hoverBackground: 'rgba(20, 142, 40, 0.08)',
              activeBackground: 'rgba(20, 142, 40, 0.16)',
              borderColor: 'rgba(20, 142, 40, 0.28)',
              color: 'rgb(20, 142, 40)',
            },
          },
          text: {
            success: {
              hoverBackground: 'rgba(20, 142, 40, 0.08)',
              activeBackground: 'rgba(20, 142, 40, 0.16)',
              color: 'rgb(20, 142, 40)',
            },
          },
        },
        dark: {
          root: {
            success: {
              background: 'rgb(20, 142, 40)',
              hoverBackground: 'rgb(28, 162, 51)',
              activeBackground: 'rgb(40, 184, 64)',
              borderColor: 'rgb(20, 142, 40)',
              hoverBorderColor: 'rgb(28, 162, 51)',
              activeBorderColor: 'rgb(40, 184, 64)',
              color: '#ffffff',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
              focusRing: {
                color: 'rgb(20, 142, 40)',
                shadow: 'none',
              },
            },
          },
          outlined: {
            success: {
              hoverBackground: 'rgba(20, 142, 40, 0.12)',
              activeBackground: 'rgba(20, 142, 40, 0.22)',
              borderColor: 'rgba(20, 142, 40, 0.5)',
              color: 'rgb(40, 184, 64)',
            },
          },
          text: {
            success: {
              hoverBackground: 'rgba(20, 142, 40, 0.12)',
              activeBackground: 'rgba(20, 142, 40, 0.22)',
              color: 'rgb(40, 184, 64)',
            },
          },
        },
      },
    },
  },
})

const i18n = createI18n({
  legacy: false,
  allowComposition: true,
  locale: 'ru',
  messages: {
    ru: ruLocale,
  },
})

const app = createApp(App)
const pinia = createPinia()
app.use(i18n)
app.use(PrimeVue, {
  theme: {
    preset: MyPreset,
    options: {
      prefix: 'p',
      darkModeSelector: 'false',
    },
  },
  locale: ruLocale,
})
app.use(ConfirmationService)
app.use(ToastService)
app.use(DialogService)
app.use(pinia)
app.use(router)

app.mount('#app')
